export default "5401d96ab7883974.svg"